// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "customer." + chunkId + "." + {"libs_customer_customer-inventory-v1_src_index_ts":"f31481b2402a8b1d","libs_customer_customer-documents-v1_src_index_ts":"e9b73d63d4da6845","libs_customer_customer-approvals-v1_src_index_ts":"be8555d0a6fdbd3f"}[chunkId] + ".js";
};